import { ChangeEvent, useState } from 'react'
import { ActivateScheduleEmailsThunk, DeactivateScheduleEmailsThunk, ScheduleEmail } from '../../../redux/slices/components/ScheduleEmails/scheduleEmailsSlice'
import { useAppDispatch } from '../../../redux/store/store'
import ButtonBack from '../../ManageAllOffers/DetailedOfferScreen/ButtonBack/ButtonBack'
import moment from 'moment'
import { checkErrors, ValuesForm } from '../../../utils/verifications/Forms'
import GeneralInputTitle from '../../UIcomponents/GeneralInputTitle/GeneralInputTitle'
import InputList from '../../UIcomponents/InputList/InputList'
import { MyYup } from '../../../utils/verifications/myYup'
import i18next from 'i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./EditScheduleEmailView.css"
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom'
import useGetScheduleText from '../../hooks/useGetScheduleText/useGetScheduleText'
import ConModalArchivedScheduleEmail from './ConModalArchivedScheduleEmail/ConModalArchivedScheduleEmail'

type EditScheduleEmailViewProps = {
    id: string
    scheduleEmail: ScheduleEmail
}

const EditScheduleEmailView = ({ id, scheduleEmail }: EditScheduleEmailViewProps) => {

    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const { t } = i18next

    const [inputValues, setInputValues] = useState<ValuesForm>({
        subject: { error: "", value: scheduleEmail.subject, touched: false, checkValue: (x: string | number, dv?: boolean) => new MyYup(x, i18next.language, dv).isRequired().isString().justValidCharacters()},
        bodyEmail: { error: "", value: scheduleEmail.bodyEmail, touched: false, checkValue: (x: string | number, dv?: boolean) => new MyYup(x, i18next.language, dv).isString().justValidCharacters()},
    })
    const [showArchivedModal, setShowArchivedModal] = useState(false)

    const { textHourDate, alreadyExecutedOneTime } = useGetScheduleText({ type: "Schedule", schedule: scheduleEmail.schedule, frecuencyId: scheduleEmail.frecuency })


    const onChangeValueInput = (newEvent: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        checkErrors(newEvent, inputValues, setInputValues)
    }

    const onChangeFocusInput = (name: string) => {
        setInputValues({...inputValues, [name]: {...inputValues[name], touched: true}}) 
    }


    const activateSchedule = () => {
        dispatch( ActivateScheduleEmailsThunk(scheduleEmail.id) )
    }

    const onShowArchivedModal = () => {
        setShowArchivedModal(true)
    }

    const onCloseArchivedModal = () => {
        setShowArchivedModal(false)
    }

    const deactivateSchedule = (e: any) => {
        e.preventDefault()
        dispatch( DeactivateScheduleEmailsThunk(scheduleEmail.id) )
        onCloseArchivedModal()
    }

    const onSubmit = (e: any) => {
        e.preventDefault()
        navigate(`/schedule-emails/${scheduleEmail.id}/update`)
    }

    const onRepost = (e: any) => {
        e.preventDefault()
        navigate(`/schedule-emails/${scheduleEmail.id}/update?repost=true`)
    }

    return (
        <div className="">
            <div className="fs-18 fw-700 mb-30">
                {t("Emails:schedule:index:label_20")}
            </div>
            <div className="flex">
                
                <div className="con-create-notification">

                    <div className="con-p-left-notification flex flex-ai-center flex-jc-sb">
                        <div className="">
                            <p className="fs-18 fw-600">
                            {t("Emails:schedule:index:label_28")}
                            </p>

                            <p className="fs-12 mt-16">
                                {`${t("Emails:schedule:index:label_29")}: ${moment(scheduleEmail.creationDate).format("D MMMM YYYY - HH[h]mm")}`}
                            </p>
                        </div>

                        {   
                            /*
                            scheduleEmail.activated
                            ? null
                            :
                            */
                            <div className="flex flex-d-column">
                                <p className="color-times-counter fw-700 fs-16">{t("Emails:schedule:index:label_40")}</p>
                                <div className="flex flex-ai-end">
                                    <p className="color-times-counter fw-700 fs-30">{scheduleEmail.counter}</p>
                                    <p className="color-times-counter fw-700 fs-16 mb-4 ml-8">{t("Emails:schedule:index:label_41")}</p>
                                </div>
                            </div>
                        }
                    </div>
                    

                    <div className="flex flex-ai-center">
                        <ButtonBack />
                        <div className="line-gray-help"></div>
                    </div>

                    <div className="con-p-left-notification-edit center flex-d-column">
                        
                        <div className="con-p-inputs-notification">
                            <p className="fs-12 mb-4 fw-600 mt-20">
                                {t("Emails:schedule:index:label_27")}
                            </p>
                            <GeneralInputTitle 
                                title={`Title`}
                                name={"subject"}
                                value={inputValues["subject"].value}
                                onChange={onChangeValueInput}
                                onFocus={onChangeFocusInput}
                                placeholder={t("Emails:schedule:index:label_04")}
                                error={inputValues["subject"].error}
                                width="100%"
                                hideTitle={true}
                                titleAbove={true}
                                readOnly={true}
                            />
                
                            <p className="fs-12 mb-4 mt-10">
                                {t("Emails:schedule:index:label_05")}
                            </p>
                            <GeneralInputTitle 
                                title={t("Emails:schedule:index:label_05")}
                                name={"bodyEmail"}
                                value={inputValues["bodyEmail"].value}
                                onChange={onChangeValueInput}
                                onFocus={onChangeFocusInput}
                                placeholder={t("Emails:schedule:index:label_06")}
                                error={inputValues["bodyEmail"].error}
                                width="100%"
                                hideTitle={true}
                                titleAbove={true}
                                textArea={{ height: "6rem" }}
                                readOnly={true}
                            />
                        </div>

                        <div className="con-p-inputs-notification width-100">

                            <div className="flex">
                                <p className={`fs-14 ${alreadyExecutedOneTime ? "color-times-counter" : ""}`}>{`${t("Emails:schedule:index:label_39")}: `}<span className="fw-600">{textHourDate}</span></p>
                            </div>

                            <div className="line-gray-help mt-20 mb-20"></div>

                            {
                                scheduleEmail.activated ?
                                <div className="flex flex-jc-sb width-100">
                                    <button
                                        onClick={scheduleEmail.activated ? onShowArchivedModal : activateSchedule}
                                        className="archived-btn-notif fs-12"
                                    >
                                        {scheduleEmail.activated ? t("Emails:schedule:index:label_22") : t("Emails:schedule:index:label_21")}
                                    </button>

                                    <button
                                        onClick={onSubmit}
                                        className="modify-btn-notif fs-12"
                                    >
                                        {t("Emails:schedule:index:label_26")}
                                    </button>
                                </div>
                                :
                                <div className="flex flex-jc-end width-100">
                                    <button
                                        onClick={onRepost}
                                        className="archived-btn-notif fs-12"
                                    >
                                        {t("Emails:schedule:index:label_38")}
                                    </button>

                                </div>
                            }
                        </div>
                        
                    </div>

                </div>

                <div className="flex-1 center">
                    <div className="con-right-notif flex flex-d-column flex-ai-end">

                        <div className={`center active-square-notif ${scheduleEmail.activated ? "active-square-notif-activated" : "active-square-notif-archived"}`}>
                            <FontAwesomeIcon 
                                icon={faCheckCircle}
                                className={`${scheduleEmail.activated ? "icon-check-notif" : "color-error"} fs-18`} 
                            />
                            <p className="fs-14 ml-4">{scheduleEmail.activated ? t("Emails:schedule:index:label_21") : t("Emails:schedule:index:label_22")}</p>
                        </div>

                        <div className="mt-20">
                            <p className="fs-14 mb-8 mt-20">
                                {t("Emails:schedule:index:label_07")}
                            </p>
                            <div className="padding-to-show-error">
                                <InputList 
                                    text={t(`Emails:schedule:device:${scheduleEmail.device}`)}  
                                    width={"13rem"}
                                    fontSize="fs-11"
                                    heightList="13rem"
                                    height="3.4rem"
                                    blockList={true}
                                >
                                    <div className=""></div>
                                </InputList>
                            </div>
                        </div>

                        <div className="mt-20">
                            <p className="fs-14 mb-8">
                                {t("Emails:schedule:index:label_08")}
                            </p>
                            <div className="padding-to-show-error">
                                <InputList 
                                    text={t(`Emails:schedule:topic:${scheduleEmail.topic}`)}  
                                    width={"13rem"}
                                    fontSize="fs-11"
                                    heightList="13rem"
                                    height="3.4rem"
                                    blockList={true}
                                >
                                    <div className=""></div>
                                </InputList>
                            </div>
                        </div>

                        <div className="mt-20">
                            <p className="fs-14 mb-8">
                                {t("Emails:schedule:index:label_09")}
                            </p>
                            <div className="padding-to-show-error">
                                <InputList 
                                    text={t(`Emails:schedule:frecuency:${scheduleEmail.frecuency}`)}  
                                    width={"13rem"}
                                    fontSize="fs-11"
                                    heightList="13rem"
                                    height="3.4rem"
                                    blockList={true}
                                >
                                    <div className=""></div>
                                </InputList>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

            {
                showArchivedModal ?
                <ConModalArchivedScheduleEmail
                    onCloseModal={onCloseArchivedModal}
                    onSubmit={deactivateSchedule}
                />
                : null
            }
        </div>
    )
}

export default EditScheduleEmailView